<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#"><b>KAPPS.me</b></b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item href="#" v-for="opt in menus" :key="opt">{{
              opt
            }}</b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "MainNavBar",
  components: {},
  data() {
    return {
      menus: ["Contacto", "Acerca"],
    };
  },
};
</script>

<style scoped>
nav.navbar {
  box-shadow: 0 0.25rem 0.25rem rgb(0 0 0 / 25%),
    inset 0 -1px 5px rgb(0 0 0 / 25%);
}
.navbar-brand {
  font-size: 2rem;
  line-height: 1.07143;
  font-weight: 600;
  letter-spacing: -0.005em;
  font-family: "SF Pro Display", "SF Pro Icons", "Helvetica Neue", "Helvetica",
    "Arial", sans-serif;
}
</style>
